module.exports = __webpack_public_path__ + "static/img/coffee.73d5e0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coffee.png
// module id = 221
// module chunks = 1